export var raRbacLanguageEnglish = {
    'ra-rbac': {
        page: {
            unauthorized: 'Unauthorized',
        },
        message: {
            unauthorized: 'You are not allowed to access this page',
        },
    },
};
